import GoogleClientBase from "./GoogleClientBase";
import { googleJson } from "./request";

class Spreadsheet extends GoogleClientBase {
  getLink(fileId: string): string {
    return `https://docs.google.com/spreadsheets/d/${fileId}/edit#gid=0`;
  }

  async create(title: string): Promise<string> {
    const response = await googleJson<{ spreadsheetId?: string }>("https://sheets.googleapis.com/v4/spreadsheets", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        properties: {
          title,
        },
      }),
    });

    const { spreadsheetId } = response;

    if (!spreadsheetId) {
      throw new Error("Google Sheet created with empty ID.");
    }

    return spreadsheetId;
  }
};

export default new Spreadsheet();
